import { ClearOutlined } from "@ant-design/icons";

import { FC } from "react";
import { MazakaButton } from "./MazakaButton";
import { useDispatch } from "react-redux";

interface MazakaClearFiltersProps {
  buttonBlock?: boolean;
  resetFunc:any
}

const MazakaClearFilters: FC<MazakaClearFiltersProps> = (props) => {
  const dispatch = useDispatch()
  return (
    <>
      <MazakaButton
        className=" focus:!text-white !items-center hover:!bg-[#FFC502] hover:!text-black !text-xs !p-2 md:!p-4 md:!text-sm !hidden lg:!flex"
        type="text"
        onClick={() => {
          dispatch(props.resetFunc())
        }}
        icon={<ClearOutlined />}
        block={props.buttonBlock}
      >
        {"Filtreyi Temizle"}
      </MazakaButton>
    </>
  );
};

export default MazakaClearFilters;
